import { useState } from 'react'
import { DashboardCardProps } from './types.ts'
import styles from './DashboardCard.module.scss'
import { Button } from '@boltenergy-be/design-system'

const ExportButton = ({ handleExport, disableExport }: Pick<DashboardCardProps, 'handleExport' | 'disableExport'>) => {
  const [exporting, setExporting] = useState(false)

  if (typeof handleExport !== 'function') return null

  const onClick = async () => {
    setExporting(true)

    try {
      await handleExport()
    } finally {
      setExporting(false)
    }
  }

  return (
    <Button
      size="small"
      className={styles.export}
      trailingIcon="fileDownload"
      representation="link"
      loading={exporting}
      disabled={disableExport}
      onClick={onClick}
    >
      Export
    </Button>
  )
}

export default ExportButton
